import DataController from "../DataController";
import SingleLanguageString from "./SingleLanguageString";
import ObjectID from "bson-objectid";
import Language from "./Language";
import {isValidId} from "../../basic";
export default class MultiLanguageString extends DataController{
    public languages: SingleLanguageString[] = [];

    constructor(languages: SingleLanguageString[] = []){
        super();
        this.languages = languages;
    }

    public guessContentSelection(self, preferredLanguageDescriptor, forceLanguage: boolean= false){
        const preferredLanguage = preferredLanguageDescriptor.upper();

        let content = "";
        let language = null;
        if(this.languages.length > 0){
            for(const l of this.languages){
                if((l.getLanguage().getDescriptor() === preferredLanguageDescriptor) ||
                        (! forceLanguage && l.getLanguage().getDescriptor() === "*") ||
                        (! forceLanguage && language === null)){
                    content = l.getValue();
                    language = l.getLanguage();
                    if(l.getLanguage().getDescriptor() === preferredLanguageDescriptor){
                        break;
                    }
                }
            }
        }

        return {
            content,
            isOriginal: language !== null && language.getDescriptor().upper() === preferredLanguage,
            language,
        };
    }

    public async asList(): Promise<object[]>{
        return [...await Promise.all(this.languages.map(async (l) => (await l.asDict())))];
    }

    public getLanguages(){
        return this.languages;
    }

    /**
     * Returns the requested language information (SingleLanguageString).
     * If there is no SingleLanguageString available that matches the provided languageIdentifier, return null. 
     * 
     * @param languageIdentifier Language identifier to look for
     * @returns The requested SingleLanguageString or null if none found
     */
    public getLanguage(languageIdentifier: ObjectID): SingleLanguageString{
        if(isValidId(languageIdentifier))
            languageIdentifier = new ObjectID(languageIdentifier.toString());
        else
            return null;
        for(let i = 0; i<this.languages.length; i++){
            let language = this.languages[i];
            if(language.getLanguage().getIdentifier().equals(languageIdentifier))
                return language;
        }
        return null;
    }

    /**
     * Adds a value in a given language. If this language is already present, the value of that language is updated, otherwise it is added.
     * @param language Language to use
     * @param value Value to set
     */
    public addLanguage(language: Language, value: string): void{
        const existing = this.getLanguage(language.getIdentifier());
        if(existing === null)
            this.languages.push(new SingleLanguageString(language, value));
        else
            existing.setValue(value);
    }

    public clone(): MultiLanguageString{
        const clonedLanguages = this.languages.map<SingleLanguageString>((x: SingleLanguageString) => x.clone());
        return new MultiLanguageString(clonedLanguages);
    }

}
